export enum CampaignStatusEnum {
    PRIVATE = 'private',
    PUBLISHED = 'published',
    DRAFT = 'draft',
}
